module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Demi.fcbacfa2.woff";